// Central brand + content data for Beyond The Stage Academy
// Aligned with official Brand Guidelines + Site Map v1.0

export const BRAND = {
  name: "Beyond The Stage Academy",
  short: "BTSA",
  tagline: "Building Voices. Shaping Futures.",
  hero_headline_primary: "Find Your Voice.",
  hero_headline_secondary: "Own Your Presence.",
  hero_headline_tertiary: "Transform Your Future.",
  founder_name: "Kiran Pandit",
  founder_role: "Founder & Communication Coach",
  domain: "beyondthestageacademy.me",
  email: "kiran@beyondthestageacademy.me",
  phone: "+91 77750 41196",
  phone2: "+91 90110 16984",
  whatsapp: "917775041196",
  address: "Beyond The Stage Academy, Pune, Maharashtra, India",
  mapEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d121060.51!2d73.72!3d18.52!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bf2e67461101%3A0x828d43bf9d9ee343!2sPune%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1700000000000",
  logo: "/btsa-logo.jpg",
  logo_mark: "/btsa-logo-mark.jpg",
  founder_image:
    "https://static.prod-images.emergentagent.com/jobs/11947d56-1ac6-4f5a-8175-03574db124a6/images/99b114a56bb5e9a366f04a27694697bb86c6c14bcf6c78eb639a231fadaf9922.png",
};

// Admission fee payment details — EDIT THESE (leave qrImage "" to show a placeholder)
export const PAYMENT = {
  qrImage: "/payment-qr.jpeg",
  upiId: "grace1984@ybl",
  accountHolder: "Kiran Vishal Pandit",
};

// Admission form options
export const ADMISSION_PROGRAMS = [
  "Junior Communicators (Grades 1–3)",
  "Emerging Speakers (Grades 4–6)",
  "Confident Communicators (Grades 7–10)",
  "Senior Communicators (Grades 11–12)",
];

export const ADMISSION_BATCHES = [
  "Saturday Morning",
  "Saturday Afternoon",
  "Sunday Morning",
  "Sunday Afternoon",
  "Flexible",
];


export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Programs", to: "/programs" },
  { label: "Journey", to: "/student-journey" },
  { label: "Curriculum", to: "/curriculum" },
  { label: "Trinity", to: "/trinity" },
  { label: "Success", to: "/success-stories" },
  { label: "Schools", to: "/for-schools" },
  { label: "Gallery", to: "/gallery" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

export const FOCUS_AREAS = [
  { title: "Communication", desc: "Articulate ideas with clarity, intent and grace." },
  { title: "Confidence", desc: "Inner certainty that radiates in every room." },
  { title: "Creativity", desc: "Imagination, voice and individuality, unleashed." },
  { title: "Leadership", desc: "Decisiveness, empathy and the courage to lead." },
  { title: "Stage Presence", desc: "Command attention. Hold the room. Speak to inspire." },
  { title: "Critical Thinking", desc: "Frame, question and solve with structured reasoning." },
  { title: "Public Speaking", desc: "Voice, diction and theatrical expression refined." },
  { title: "Expression", desc: "Creativity as a powerful form of communication." },
];

// "Beyond Marks. Beyond Memorisation. Beyond Limits." — six pillars
export const BEYOND_PILLARS = [
  { title: "Communication", desc: "Expressing ideas with clarity, intent and grace — on stage and in life." },
  { title: "Confidence", desc: "The quiet certainty of a child who knows their voice matters." },
  { title: "Creativity", desc: "Imagination and individuality, unleashed through play and performance." },
  { title: "Critical Thinking", desc: "Framing, questioning and solving with structured, original reasoning." },
  { title: "Leadership", desc: "Empathy, decisiveness and the courage to lead in any room." },
  { title: "Character", desc: "Integrity, resilience and values that carry well beyond the classroom." },
];

// BTSA Growth Model — the journey every child travels
export const GROWTH_MODEL = [
  { step: "Voice", desc: "The first courageous moments of being heard." },
  { step: "Confidence", desc: "Comfort, composure and self-belief on every stage." },
  { step: "Communication", desc: "Expressing ideas clearly, persuasively and with poise." },
  { step: "Leadership", desc: "Inspiring, guiding and representing with responsibility." },
  { step: "Impact", desc: "A confident voice that shapes classrooms, communities and futures." },
];

// The Beyond Difference — why students grow faster at BTSA
export const BEYOND_DIFFERENCE = [
  { title: "Learn by Doing", desc: "Children learn by performing and reflecting — never by memorising alone." },
  { title: "Age-Specific Curriculum", desc: "Tailored content matched precisely to each stage of development." },
  { title: "Weekly Speaking Opportunities", desc: "Regular practice that builds confidence and consistency, session after session." },
  { title: "Communication First", desc: "Confidence is the foundation; clear communication is the outcome." },
  { title: "Leadership Pathway", desc: "A structured path from first words to confident, articulate leadership." },
  { title: "Continuous Feedback", desc: "Personal, encouraging feedback that refines every learner individually." },
];

export const PROGRAMS = [
  {
    slug: "junior-communicators",
    title: "Junior Communicators",
    ageGroup: "Ages 6 – 10",
    image:
      "https://images.unsplash.com/photo-1597743622436-c6b5661731e0?auto=format&fit=crop&w=1400&q=80",
    overview:
      "An immersive introduction to the language of confidence — speaking, storytelling, listening and creative thinking, designed for young learners stepping onto their very first stage.",
    focus: ["Speaking & Expression", "Storytelling", "Listening Skills", "Confidence Building", "Creative Thinking"],
    outcomes: [
      "Clear, confident articulation in everyday conversation",
      "Foundations of stage presence and eye contact",
      "Listening, turn-taking and respectful expression",
      "Joyful comfort with speaking aloud",
    ],
    benefits: [
      "Early confidence that compounds for life",
      "Strong classroom participation",
      "Curiosity that turns into expression",
    ],
  },
  {
    slug: "emerging-leaders",
    title: "Emerging Leaders",
    ageGroup: "Ages 11 – 14",
    image:
      "https://images.unsplash.com/photo-1572847748080-bac263fae977?auto=format&fit=crop&w=1400&q=80",
    overview:
      "The studio years. Public speaking, communication craft, leadership foundations and the art of presenting — all rehearsed in small, supportive cohorts.",
    focus: ["Public Speaking", "Communication Skills", "Leadership Foundations", "Teamwork", "Presentations"],
    outcomes: [
      "Persuasive structure: hook, body, close",
      "Body language, pacing and vocal command",
      "Team facilitation and collaborative thinking",
      "Composure with audience and Q&A",
    ],
    benefits: [
      "Distinction in school competitions",
      "Confident presenter in any room",
      "Leadership instincts that compound",
    ],
  },
  {
    slug: "teen-leadership-academy",
    title: "Teen Leadership Academy",
    ageGroup: "Ages 15 – 18",
    image:
      "https://images.unsplash.com/photo-1538449327350-43b4fcfd35ac?auto=format&fit=crop&w=1400&q=80",
    overview:
      "From advanced public speaking to debate, persuasion and stage presence — a finishing school for teenagers preparing to lead rooms, not just enter them.",
    focus: ["Advanced Public Speaking", "Debates", "Persuasive Communication", "Leadership", "Stage Presence"],
    outcomes: [
      "Argumentation, rebuttal and rhetorical fluency",
      "Polished stage presence and executive composure",
      "Critical research and structured persuasion",
      "Interview-ready presence and poise",
    ],
    benefits: [
      "University-application advantage",
      "Distinction in MUN, debate and public forums",
      "A lifelong professional foundation",
    ],
  },
];

export const CURRICULUM = [
  { title: "Communication Skills", desc: "Articulation, active listening, conversational poise and the elegance of everyday speech.", image: "https://images.unsplash.com/photo-1682962232755-f1d051ddb638?auto=format&fit=crop&w=900&q=80" },
  { title: "Public Speaking", desc: "Structure, delivery, audience awareness and the discipline of speaking with purpose.", image: "https://images.unsplash.com/photo-1538449327350-43b4fcfd35ac?auto=format&fit=crop&w=900&q=80" },
  { title: "Speech & Drama", desc: "Voice, diction, characterisation, monologue and ensemble performance.", image: "https://images.unsplash.com/photo-1667386427340-ea2cbca9ad01?auto=format&fit=crop&w=900&q=80" },
  { title: "Reading & Interpretation", desc: "Expressive reading, comprehension through performance and interpretation of texts.", image: "https://images.unsplash.com/photo-1692269725911-87697c558be1?auto=format&fit=crop&w=900&q=80" },
  { title: "Creative Thinking", desc: "Lateral problem-solving, design thinking and imaginative idea generation.", image: "https://images.unsplash.com/photo-1623303366639-0e330d7c3d9f?auto=format&fit=crop&w=900&q=80" },
  { title: "Leadership", desc: "Decisiveness, empathy, team facilitation and the courage to lead in any room.", image: "https://images.unsplash.com/photo-1572847748080-bac263fae977?auto=format&fit=crop&w=900&q=80" },
  { title: "Life Skills", desc: "Time mastery, accountability, resilience and the rituals of personal excellence.", image: "https://images.unsplash.com/photo-1573894998033-c0cef4ed722b?auto=format&fit=crop&w=900&q=80" },
  { title: "Presentation Skills", desc: "Slide craft, storytelling with data, pacing and on-stage composure.", image: "https://images.unsplash.com/photo-1647187977315-38f612032998?auto=format&fit=crop&w=900&q=80" },
];

export const VALUES = [
  { letter: "C", title: "Communication", desc: "Speaking and listening with clarity, care and craft." },
  { letter: "C", title: "Confidence", desc: "The quiet certainty of knowing one's voice matters." },
  { letter: "C", title: "Creativity", desc: "Original thought, imaginative expression, the courage to make." },
  { letter: "L", title: "Leadership", desc: "Decisiveness, empathy and the courage to lead." },
  { letter: "E", title: "Excellence", desc: "Every interaction reflects quality and professionalism." },
];

export const JOURNEY = [
  { n: "01", title: "Discover", subtitle: "Finding My Voice", desc: "The first courageous moments — speaking up, being heard, realising that one's voice has weight." },
  { n: "02", title: "Explore", subtitle: "Building Skills", desc: "Foundational craft: diction, structure, listening, expression and the basic disciplines of communication." },
  { n: "03", title: "Grow", subtitle: "Expressing Ideas", desc: "From technique to thought — original ideas, structured arguments and confident self-expression." },
  { n: "04", title: "Lead", subtitle: "Influencing Others", desc: "Persuasion, leadership and the responsibility of using one's voice for collective good." },
  { n: "05", title: "Excel", subtitle: "Making An Impact", desc: "Mastery on stage, in life and in pursuit of ambitions far beyond the classroom." },
];

export const PARENT_PILLARS = [
  { title: "Small Group Learning", desc: "Intimate cohorts that protect every child's voice." },
  { title: "Individual Attention", desc: "Every learner is observed, mentored, refined personally." },
  { title: "Experiential Learning", desc: "Doing, performing, reflecting — not memorising." },
  { title: "Trinity Pathway", desc: "Internationally recognised Trinity College London qualifications." },
  { title: "Real-World Communication", desc: "Skills built for the stage, the classroom and life." },
];

export const TESTIMONIALS = [
  { quote: "The transformation in our daughter has been profound. She walks into a room differently — composed, articulate, fully herself.", name: "Anjali Mehta", role: "Parent · Age 11" },
  { quote: "BTSA is not a class, it is a finishing school for the modern child. The faculty are artists and educators in equal measure.", name: "Rohan Kulkarni", role: "Parent · Ages 9 & 13" },
  { quote: "Our son went from quiet observer to elocution champion. More importantly, he found a voice he believes in.", name: "Sneha Iyer", role: "Parent · Age 14" },
  { quote: "The attention to detail — from how children are greeted to how feedback is given — is unlike anything we have seen.", name: "Aditya Sharma", role: "Parent · Age 8" },
];

export const ADMISSIONS_STEPS = [
  { n: "01", title: "Enquiry", desc: "Share a few details about your child. Our team responds within one working day with curated next steps." },
  { n: "02", title: "Discovery Session", desc: "A complimentary 1-on-1 conversation to understand your child's temperament, interests and developmental goals." },
  { n: "03", title: "Program Recommendation", desc: "We propose the program, cohort and journey that best fits your child — never one-size-fits-all." },
  { n: "04", title: "Enrollment", desc: "Secure your child's seat. Receive the welcome kit, schedule and an introduction to faculty." },
];

export const TRINITY = {
  intro: "Trinity College London is one of the world's leading awarding bodies for performing arts qualifications, with a 145-year heritage of recognised excellence in speech, drama and communication.",
  why: [
    "Internationally recognised qualification",
    "Globally benchmarked syllabus and assessment",
    "Real performance, not rote memorisation",
    "Builds genuine confidence and presence",
    "Strengthens university and career applications",
  ],
  grades: ["Initial", "Grade 1", "Grade 2", "Grade 3", "Grade 4", "Grade 5", "Grade 6", "Grade 7", "Grade 8"],
  process: [
    "Diagnostic & grade recommendation",
    "Term-paced syllabus coaching",
    "Mock examinations & feedback",
    "Final Trinity examination at recognised centre",
    "Certification & onward grade pathway",
  ],
};

export const SUCCESS_STORIES = [
  { name: "Aarav Deshmukh", program: "Teen Leadership Academy", quote: "I went from refusing to speak in class to winning the inter-school MUN best delegate. BTSA gave me a voice I didn't know I had.", image: "https://images.unsplash.com/photo-1603185030522-05d4497bb180?auto=format&fit=crop&w=600&q=80" },
  { name: "Ira Bhandari", program: "Junior Communicators", quote: "Reading aloud was once my biggest fear. Now I host school assemblies. My parents say I am a different child.", image: "https://images.unsplash.com/photo-1630864972901-052dfdc7fba4?auto=format&fit=crop&w=600&q=80" },
  { name: "Vivaan Joshi", program: "Emerging Leaders", quote: "The BTSA stage taught me composure. I cleared my school interview without a single nervous pause.", image: "https://images.unsplash.com/photo-1623303366639-0e330d7c3d9f?auto=format&fit=crop&w=600&q=80" },
];

export const SCHOOLS_OFFERINGS = [
  { title: "School Communication Program", desc: "A year-long, structured in-school program integrating BTSA's communication curriculum into the regular school calendar." },
  { title: "School Presenter Project", desc: "Train a cohort of student presenters and emcees — the voices and faces of every school event, assembly and showcase." },
  { title: "Leadership Development Programs", desc: "Curated leadership tracks for student councils, prefects and aspiring school captains." },
  { title: "Annual Showcase Model", desc: "A culminating performance event that publicly demonstrates each school's communication transformation." },
];

export const GALLERY = [
  { cat: "Workshops", src: "https://images.unsplash.com/photo-1637589316488-6d4c41b335cd?auto=format&fit=crop&w=1400&q=80" },
  { cat: "Performances", src: "https://images.unsplash.com/photo-1763733593491-e81f18a116af?auto=format&fit=crop&w=1400&q=80" },
  { cat: "Showcases", src: "https://images.unsplash.com/photo-1610093435813-526af1b3fe11?auto=format&fit=crop&w=1400&q=80" },
  { cat: "Student Activities", src: "https://images.unsplash.com/photo-1524069290683-0457abfe42c3?auto=format&fit=crop&w=1400&q=80" },
  { cat: "Workshops", src: "https://images.unsplash.com/photo-1692269725911-87697c558be1?auto=format&fit=crop&w=1400&q=80" },
  { cat: "Performances", src: "https://images.unsplash.com/photo-1667386427340-ea2cbca9ad01?auto=format&fit=crop&w=1400&q=80" },
  { cat: "Showcases", src: "https://images.unsplash.com/photo-1538449327350-43b4fcfd35ac?auto=format&fit=crop&w=1400&q=80" },
  { cat: "Student Activities", src: "https://images.unsplash.com/photo-1597743622436-c6b5661731e0?auto=format&fit=crop&w=1400&q=80" },
  { cat: "Workshops", src: "https://images.unsplash.com/photo-1682962232755-f1d051ddb638?auto=format&fit=crop&w=1400&q=80" },
  { cat: "Performances", src: "https://images.unsplash.com/photo-1647187977315-38f612032998?auto=format&fit=crop&w=1400&q=80" },
  { cat: "Showcases", src: "https://images.unsplash.com/photo-1573894998033-c0cef4ed722b?auto=format&fit=crop&w=1400&q=80" },
  { cat: "Student Activities", src: "https://images.unsplash.com/photo-1623303366639-0e330d7c3d9f?auto=format&fit=crop&w=1400&q=80" },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1763733593491-e81f18a116af?auto=format&fit=crop&w=1900&q=80";

export const TRINITY_FAQ = [
  {
    q: "What exactly is the Trinity College London qualification?",
    a: "Trinity College London is a globally recognised awarding body for performing arts and communication. Its Speech & Drama and Communication Skills examinations assess a learner's ability to speak, present and perform — producing an internationally benchmarked certificate, not a rote test score.",
  },
  {
    q: "What ages can take Trinity examinations?",
    a: "Trinity offers a graded pathway suitable from young children through teenagers. At BTSA we assess each child individually and recommend the right entry grade — from Initial level for our youngest communicators up to higher grades for confident teens.",
  },
  {
    q: "How long does it take to prepare for a grade?",
    a: "Most learners prepare across a single term of weekly coaching, including syllabus practice, rehearsal and mock examinations. The exact pace is tailored to your child's starting point and the grade being attempted.",
  },
  {
    q: "Are the exams stressful for children?",
    a: "Not at all — that is the point. Trinity assessments are performance-based and encouraging. Our preparation focuses on confidence and enjoyment, so children arrive feeling rehearsed, supported and genuinely excited to perform.",
  },
  {
    q: "How do Trinity grades help with school and university?",
    a: "Trinity certificates are recognised worldwide and strengthen school portfolios, scholarship and university applications. More importantly, the underlying skills — clarity, presence and persuasion — give students a lasting real-world advantage.",
  },
  {
    q: "Where are the examinations held?",
    a: "Examinations are conducted at recognised Trinity assessment centres by trained Trinity examiners. Our team handles registration and guides families through every step of the process.",
  },
];

export const BLOG = [
  {
    slug: "communication-the-skill-schools-forget",
    title: "Why Communication Is the Skill Schools Forget to Teach",
    category: "Communication",
    date: "12 June 2026",
    readTime: "5 min read",
    image:
      "https://images.unsplash.com/photo-1647187977315-38f612032998?auto=format&fit=crop&w=1400&q=80",
    excerpt:
      "Marks measure memory. But the children who thrive are the ones who can speak, listen and lead. Here is why communication deserves a place at the centre of every child's education.",
    content: [
      "For decades, education has been measured in marks — a number that captures how much a child can memorise and reproduce on a single day. Yet the moment a child steps beyond the exam hall, the world begins asking an entirely different question: can you express what you think?",
      "Communication is the quiet engine behind almost every success a child will ever have. The confident classroom answer, the school assembly, the scholarship interview, the first job — each is won not by what a child knows, but by how clearly they can share it.",
      "At Beyond The Stage Academy, we treat communication as a discipline in its own right. Through speaking, storytelling, listening and performance, children learn to organise their thoughts, hold a room and speak with intent. These are not soft skills. They are the hardest-working skills a child will ever own.",
      "The good news is that communication can be taught — deliberately, joyfully and early. And when it is, every other subject becomes easier, because the child finally has the confidence to participate.",
    ],
  },
  {
    slug: "stage-fright-to-spotlight",
    title: "From Stage Fright to Spotlight: Helping Shy Children Find Their Voice",
    category: "Confidence",
    date: "2 June 2026",
    readTime: "4 min read",
    image:
      "https://images.unsplash.com/photo-1497487231007-0a45e7b4b68a?auto=format&fit=crop&w=1400&q=80",
    excerpt:
      "Shyness is not a flaw to be fixed — it is a starting point. Here is how the right environment turns hesitant whispers into confident voices.",
    content: [
      "Every confident speaker you admire was once nervous. The difference is not the absence of fear — it is the presence of practice. Shy children are not lacking ability; they are simply waiting for a safe stage on which to try.",
      "We never push a child to perform before they are ready. Instead, we build confidence in small, supported steps: a shared line in a group, a short story read aloud, a single sentence spoken to a circle of friends. Each small success becomes the foundation for the next.",
      "Small cohorts matter enormously here. In a room of fifteen, every voice is heard, every attempt is celebrated, and no child can hide at the back. Encouragement replaces evaluation, and rehearsal replaces pressure.",
      "Over a term, something remarkable happens. The child who once looked at the floor begins to look at the audience. The whisper becomes a voice. And the spotlight, once terrifying, becomes a place they are proud to stand.",
    ],
  },
  {
    slug: "beyond-marks-future-ready-children",
    title: "Beyond Marks: What Really Prepares a Child for the Future",
    category: "Parenting",
    date: "24 May 2026",
    readTime: "6 min read",
    image:
      "https://images.unsplash.com/photo-1524069290683-0457abfe42c3?auto=format&fit=crop&w=1400&q=80",
    excerpt:
      "The world your child will lead is being rewritten by technology. The skills that will keep them irreplaceable are deeply, beautifully human.",
    content: [
      "Ask any parent what they want for their child and the answer is rarely 'higher marks'. It is confidence. Happiness. The ability to stand on their own. Yet the systems around our children are still optimised almost entirely for examination.",
      "As routine work is increasingly automated, the skills that remain valuable are the ones machines cannot replicate: communication, creativity, critical thinking, leadership and character. These are precisely the capabilities a child cannot learn from a textbook alone.",
      "This is the philosophy behind everything we do — beyond marks, beyond memorisation, beyond limits. We help children build the human skills that compound over a lifetime, long after the syllabus has been forgotten.",
      "Preparing a child for the future is not about predicting which careers will exist. It is about raising a young person who can think, express and adapt — and who believes their voice is worth hearing.",
    ],
  },
  {
    slug: "speech-and-drama-child-development",
    title: "The Power of Speech & Drama in Child Development",
    category: "Speech & Drama",
    date: "10 May 2026",
    readTime: "5 min read",
    image:
      "https://images.unsplash.com/photo-1610093435813-526af1b3fe11?auto=format&fit=crop&w=1400&q=80",
    excerpt:
      "Drama is far more than performance. It is one of the most powerful tools we have for building empathy, expression and self-belief in children.",
    content: [
      "When a child steps into a character, something extraordinary happens. They experiment with emotion, take on new perspectives and discover parts of themselves they did not know existed. Drama is play with a purpose.",
      "Speech and drama train the whole communicator: voice and diction, body language and presence, listening and timing. A child learns to project, to pause, to hold attention — skills that serve them in every classroom presentation and conversation.",
      "Just as importantly, drama builds empathy. To play a character well, a child must imagine how another person feels. In doing so, they grow into more thoughtful, more emotionally intelligent young people.",
      "This is why speech and drama sit at the heart of the BTSA curriculum. We are not training children to perform for applause — we are using the stage as a rehearsal space for life.",
    ],
  },
];
